module.exports = __webpack_public_path__ + "img/c02_buildinglamellarandlaqueredleatherarmor_Normal_ua.7a817d86.webp";